import { render, staticRenderFns } from "./theWorkAnalysis.vue?vue&type=template&id=4509c50c&scoped=true&"
import script from "./theWorkAnalysis.vue?vue&type=script&lang=js&"
export * from "./theWorkAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./theWorkAnalysis.vue?vue&type=style&index=0&id=4509c50c&prod&lang=css&"
import style1 from "./theWorkAnalysis.vue?vue&type=style&index=1&id=4509c50c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4509c50c",
  null
  
)

export default component.exports